
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import { useAuthorizedSessionsStore } from '@/entities/authorized-session'

export const sessionsBeforeEnter = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  const { fetch } = useAuthorizedSessionsStore()

  await fetch()

  next()
}
